import React from "react";
import { useQuery } from "@tanstack/react-query";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import { getGalleries } from "../../services/galleryServices";
import { getLangIdFromCode } from "../../services/langUtils";

const ImageGallery = ({ language }) => {
  const langId = getLangIdFromCode(language); // 1 = hi, 2 = en

  const {
    data: galleries,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["galleries", langId],
    queryFn: ({ signal }) => getGalleries({ langId }, signal),
  });

  if (isLoading) return null;
  if (isError) {
    console.error(error);
    return null;
  }

  const galleryData = galleries || [];

  const imageGroups = galleryData.map((gallery) => ({
    title: gallery.block_name,
    images: (gallery.images || []).map((img) => ({
      src: img.image,
      thumb: img.image,
    })),
  }));

  if (!imageGroups.length) return null;

  return (
    <div className="row justify-content-center">
      {imageGroups.map((group, index) => (
        <div className="col-lg-4" key={index}>
          <div className="gallery-item">
            <span>{group.title}</span>
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              mode="lg-fade"
            >
              {group.images.map((image, idx) => (
                <a
                  key={idx}
                  href={image.src}
                  data-lg-size="1406-1390"
                  data-lg-thumbnail={image.thumb}
                >
                  <img src={image.thumb} alt="" />
                </a>
              ))}
            </LightGallery>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
